<script lang="ts">
	import { getTemplateContext } from "../template-context.svelte";

	const templateContext = getTemplateContext();
</script>

<!-- Site Wide Banner (will scroll away) -->
<div class="hidden w-full border-b bg-white py-2 md:block">
	<div class="max-w-8xl container mx-auto">
		<p class="text-primary text-center text-sm font-semibold">
			{templateContext.siteSlogan}
		</p>
	</div>
</div>
